import { Locales } from '../../models/locale/locales';

/** Every locale the app ships translations for. */
export const LOCALES: Locales[] = ['de-DE', 'en-EN', 'es-ES', 'fr-FR', 'it-IT'];

export const isValidLocale = (locale: string | null | undefined): locale is Locales =>
  !!locale && LOCALES.includes(locale as Locales);

/**
 * The locale the visitor asked for via `?lang=`, or undefined when the param is
 * missing or names a locale we do not ship.
 *
 * Deliberately does NOT fall back to a default: analytics should record that a
 * visitor arrived without a usable `?lang=` rather than silently attribute them
 * to Germany. The UI has its own fallback (see context/locale/provider.tsx).
 */
export const getUrlLocale = (search: string = window.location.search): Locales | undefined => {
  const locale = new URLSearchParams(search).get('lang');
  return isValidLocale(locale) ? locale : undefined;
};

/**
 * ISO 3166-1 alpha-2 country for a locale, for dashboards that group by country
 * rather than by locale string. `en-EN` is the UK (see the locale's own
 * languageList, which maps it to "United Kingdom") — the language tag is not a
 * real region code, so it is mapped explicitly rather than parsed.
 */
const LOCALE_COUNTRY: Record<Locales, string> = {
  'de-DE': 'DE',
  'en-EN': 'GB',
  'es-ES': 'ES',
  'fr-FR': 'FR',
  'it-IT': 'IT',
};

export const getCountry = (locale: Locales | undefined): string | undefined =>
  locale ? LOCALE_COUNTRY[locale] : undefined;
